import React, { useContext } from 'react';
import Label from '~/componentes/CustomForm/Label';
import { Input, TextArea, Select } from '~/componentes/CustomForm';
import ColoredButton from '~/componentes/Button/Styles/ColoredButton';
import sistemaListStore from '../../../../../../componentes/SistemaList/ThisMainComponent/thisStore';
import { useState } from 'react';
import { useEffect } from 'react';

import { CardAtividade, Container } from './styles';
import IconModalOrcamentoAtividade from '~/assets/icones/modal/IconModalOrcamentoAtividade.svg';
import api from '~/services/api';

function AtividadesList({ defaultData, setter, setterSoma, setterSomaLib, gerarProjeto }) {
  const atividadePad = [
    {
      item: 1,
      id: 0,
      idDesc: '0 - Sem SD',
      titulo: 'Levantamento de Requisitos',
      descricao: '',
      horaTotal: 0,
      dataInicioProjeto: '',
      dataPrevEntregaProjeto: '',
      horasPorDia: 8,
      horaInicial: '00:00',
      horaFinal: '00:00',
      dataEntregaProjeto: '',
      travarSaldo: 'S',
      analistas: [],
    },
    {
      item: 2,
      id: 0,
      idDesc: '0 - Sem SD',
      titulo: 'Desenvolvimento',
      descricao: '',
      horaTotal: 0,
      dataInicioProjeto: '',
      dataPrevEntregaProjeto: '',
      horasPorDia: 8,
      horaInicial: '00:00',
      horaFinal: '00:00',
      dataEntregaProjeto: '',
      travarSaldo: 'S',
      analistas: [],
    },
    {
      item: 3,
      id: 0,
      idDesc: '0 - Sem SD',
      titulo: 'Homologação e Correções dentro do Escopo',
      descricao: '',
      horaTotal: 0,
      dataInicioProjeto: '',
      dataPrevEntregaProjeto: '',
      horasPorDia: 8,
      horaInicial: '00:00',
      horaFinal: '00:00',
      dataEntregaProjeto: '',
      travarSaldo: 'S',
      analistas: [],
    },
    {
      item: 4,
      id: 0,
      idDesc: '0 - Sem SD',
      titulo: 'Aplicação em Produção e Acompanhamento',
      descricao: '',
      horaTotal: 0,
      dataInicioProjeto: '',
      dataPrevEntregaProjeto: '',
      horasPorDia: 8,
      horaInicial: '00:00',
      horaFinal: '00:00',
      dataEntregaProjeto: '',
      travarSaldo: 'S',
      analistas: [],
    },
  ];
  const [atividades, setAtividades] = useState([]);
  const [analistas, setAnalistas] = useState([]);
  const { state } = useContext(sistemaListStore);
  const { edit, editShow } = state?.modal || {};

  useEffect(() => {
    api
      .get('/signed/empresa/gestorprojeto/gerencia/analistas', { params: { ativo: 1 } })
      .then(r => setAnalistas(r?.data));
  }, []);

  useEffect(() => {
    if (Array.isArray(defaultData)) {
      if (defaultData?.length > 0) {
        if (edit) {
          let aAtividade = [];
          let item = 1;
          for (const itemAtividade of defaultData) {
            let analistas = [];

            for (const itemAnal of itemAtividade?.analistasAtividade ?? []) {
              // Buscar o título correspondente nos itensAtividade
              const itemCorrespondente = itemAtividade?.itensAtividade?.find(
                item => item?.idAnalista === itemAnal?.idAnalista,
              );

              analistas.push({
                id: itemAnal?.id,
                idAnalista: itemAnal?.idAnalista,
                titulo: itemCorrespondente?.titulo || '',
                horaTotal: itemAnal?.horaTotal,
                horaSaldo: itemAnal?.horaSaldo,
              });
            }

            aAtividade.push({
              item,
              id: itemAtividade?.id,
              idDesc:
                item +
                (itemAtividade?.orcamento ? ` - SD ${itemAtividade?.orcamento?.id}` : ` - Sem SD`),
              titulo: itemAtividade?.titulo,
              descricao: itemAtividade?.descricao,
              horaTotal: itemAtividade?.horaTotal,
              horaSaldo: itemAtividade?.horaSaldo,
              dataInicioProjeto: itemAtividade?.previsaoInicio,
              dataPrevEntregaProjeto: itemAtividade?.previsaoEntrega,
              dataEntregaProjeto: itemAtividade?.dataEntrega,
              horasPorDia: itemAtividade?.horasPorDia,
              horaInicial: itemAtividade?.horaInicial,
              horaFinal: itemAtividade?.horaFinal,
              travarSaldo: itemAtividade?.travarSaldo,
              analistas,
            });

            item++;
          }
          setAtividades(aAtividade);
          setter(aAtividade);
        }
      } else {
        if (!(edit && editShow)) {
          setAtividades(atividadePad);
          setter(atividadePad);
        }
      }
    }
  }, [edit, editShow]);

  useEffect(() => {
    setter(atividades);

    if (setterSoma && setterSomaLib) {
      let horaTotal = 0;
      let horaSaldo = 0;
      for (const item of atividades) {
        horaTotal += item?.horaTotal;
        horaSaldo += item?.horaSaldo;
      }

      setterSoma(horaTotal);
      setterSomaLib(horaSaldo);
    }
  }, [atividades]);

  function handleAddAtividade() {
    setAtividades(prev => [
      ...prev,
      {
        item: atividades?.length > 0 ? atividades[atividades?.length - 1]?.item + 1 : 1,
        id: 0,
        idDesc: '0 - Sem SD',
        titulo: 'Atividade de Projeto',
        descricao: '',
        horaTotal: 0,
        dataInicioProjeto: '',
        dataPrevEntregaProjeto: '',
        horasPorDia: 8,
        horaInicial: '00:00',
        horaFinal: '00:00',
        dataEntregaProjeto: '',
        travarSaldo: '',
        analistas: [],
      },
    ]);
  }

  function handleRemoveAtividade(data) {
    setAtividades(prev => {
      const newPrev = [...prev];
      const checkIndex = prev.findIndex(e => e?.item === data?.item);

      if (checkIndex >= 0) {
        newPrev.splice(checkIndex, 1);
      }

      return newPrev;
    });
  }

  function handleAddAnalista(index) {
    setAtividades(prev => {
      let newPrev = [...prev];
      let analistas = [];
      let horaTotal = 0;

      for (const itemAnal of newPrev[index].analistas) {
        horaTotal += itemAnal?.horaTotal;
        analistas.push(itemAnal);
      }
      newPrev[index].horaTotal = horaTotal > 0 ? horaTotal : newPrev[index].horaTotal;

      analistas.push({
        id: 0,
        titulo: '',
        horaTotal: analistas.length > 0 ? 0 : newPrev[index].horaTotal,
        horaSaldo: 0,
      });
      newPrev[index].analistas = analistas;

      return newPrev;
    });
  }

  function handleRemoveAnalista(index, iAnal) {
    setAtividades(prev => {
      const newPrev = [...prev];
      let analistas = [];
      let count = 0;
      let horaTotal = 0;

      for (const itemAnal of newPrev[index].analistas) {
        if (count != iAnal) {
          horaTotal += itemAnal?.horaTotal;
          analistas.push(itemAnal);
        }

        count++;
      }

      newPrev[index].analistas = analistas;
      newPrev[index].horaTotal = horaTotal;

      return newPrev;
    });
  }

  return (
    <Container>
      <Label title="Atividades *" className="titulo-label" row={true}>
        {!(editShow && edit) ? (
          <ColoredButton small blueLayout type="button" onClick={handleAddAtividade}>
            Adicionar
          </ColoredButton>
        ) : (
          <ColoredButton small disabledLayout type="button">
            Adicionar
          </ColoredButton>
        )}
      </Label>
      {atividades?.map((itemData, index) => (
        <CardAtividade key={itemData?.id}>
          <div className="card-atv-header">
            <div className="titulo">
              <div className="fundo-icon">
                <img className="atividade" src={IconModalOrcamentoAtividade} alt="Vazio" />
              </div>
              <p className="item">Item {itemData?.idDesc} </p>
            </div>
            <div
              onClick={() => {
                handleRemoveAtividade(itemData);
              }}
              className="icon-button material-icons"
            >
              delete
            </div>
          </div>
          <div className="card-atv-body">
            <div className="row no-margin row-top">
              <Label title="Titulo da Atividade * " className="col s12 m12 l6">
                <Input
                  placeholder="Titulo da Atividade"
                  name="tituloAtividadeAt"
                  required="true"
                  value={itemData?.titulo}
                  onChange={e => {
                    const v = e.currentTarget.value || '';
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].titulo = v;

                      return newPrev;
                    });
                  }}
                />
              </Label>
              <Label title="Data Inicio " className="col s12 m6 l2">
                <Input
                  type="date"
                  name="dataInicioProjetoAt"
                  value={itemData?.dataInicioProjeto}
                  onChange={e => {
                    const v = e.currentTarget.value || 0;
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].dataInicioProjeto = v;

                      return newPrev;
                    });
                  }}
                />
              </Label>
              <Label title="Data P/ Entrega " className="col s12 m6 l2">
                <Input
                  type="date"
                  name="dataPrevEntregaProjetoAt"
                  value={itemData?.dataPrevEntregaProjeto}
                  onChange={e => {
                    const v = e.currentTarget.value || 0;
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].dataPrevEntregaProjeto = v;

                      return newPrev;
                    });
                  }}
                />
              </Label>
              <Label title="Data de Entrega " className="col s12 m6 l2">
                <Input
                  type="date"
                  name="dataEntregaProjetoAt"
                  value={itemData?.dataEntregaProjeto}
                  onChange={e => {
                    const v = e.currentTarget.value || 0;
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].dataEntregaProjeto = v;

                      return newPrev;
                    });
                  }}
                />
              </Label>
            </div>
            <div className="row no-margin">
              <Label title="Hora Total * " className="col s12 m6 l2">
                <Input
                  type="number"
                  name="horaTotalAt"
                  min="1"
                  required="true"
                  value={itemData?.horaTotal}
                  onChange={e => {
                    const v = e.currentTarget.value || 0;
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].horaTotal = parseInt(v);

                      return newPrev;
                    });
                  }}
                />
              </Label>
              <Label title="HR Lib Analistas * " className="col s12 m6 l2">
                <Input
                  type="number"
                  name="horaSaldoAt"
                  step="0.10"
                  required="true"
                  value={itemData?.horaSaldo}
                  onChange={e => {
                    const v = e.currentTarget.value || 0;
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].horaSaldo = parseFloat(v);

                      return newPrev;
                    });
                  }}
                />
              </Label>
              <Label title="Travar OS P/ saldo *" className="col s12 m6 l2">
                <Select
                  required="true"
                  isString
                  list={{
                    list: [
                      { id: 'S', titulo: 'Sim' },
                      { id: 'N', titulo: 'Não' },
                    ],
                    value: 'id',
                    label: 'titulo',
                  }}
                  name="travarSaldo"
                  value={itemData?.travarSaldo}
                  onChange={e => {
                    const v = e.currentTarget.value || 0;
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].travarSaldo = v;

                      return newPrev;
                    });
                  }}
                />
              </Label>
              <Label title="Horas Por Dia * " className="col s12 m6 l2">
                <Input
                  type="number"
                  name="horasPorDiaAt"
                  min="1"
                  max="24"
                  required="true"
                  value={itemData?.horasPorDia}
                  onChange={e => {
                    const v = e.currentTarget.value || 0;
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].horasPorDia = parseInt(v);

                      return newPrev;
                    });
                  }}
                />
              </Label>
              <Label title="Hora Inicial " className="col s12 m6 l2">
                <Input
                  type="time"
                  name="horaInicialAt"
                  value={itemData?.horaInicial}
                  onChange={e => {
                    const v = e.currentTarget.value || 0;
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].horaInicial = v;

                      return newPrev;
                    });
                  }}
                />
              </Label>
              <Label title="Hora Final " className="col s12 m6 l2">
                <Input
                  type="time"
                  name="horaFinalAt"
                  value={itemData?.horaFinal}
                  onChange={e => {
                    const v = e.currentTarget.value || 0;
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].horaFinal = v;

                      return newPrev;
                    });
                  }}
                />
              </Label>
            </div>
            <div className="row no-margin">
              <div className="col s12 m12 l12">
                <TextArea
                  placeholder="Descrição da Atividade"
                  name="descAtividadeAt"
                  value={itemData?.descricao}
                  onChange={e => {
                    const v = e.currentTarget.value || '';
                    setAtividades(prev => {
                      let newPrev = [...prev];

                      newPrev[index].descricao = v;

                      return newPrev;
                    });
                  }}
                />
              </div>
            </div>
            <div className="row no-margin">
              <div className="col s12 m12 l12">
                <Label title="Analistas" className="titulo-label no-margin" row={true}>
                  {!(editShow && edit) ? (
                    <ColoredButton
                      small
                      blueLayout
                      type="button"
                      onClick={() => {
                        handleAddAnalista(index);
                      }}
                    >
                      Adicionar
                    </ColoredButton>
                  ) : (
                    <ColoredButton small disabledLayout type="button">
                      Adicionar
                    </ColoredButton>
                  )}
                </Label>
                <div className="list-analista">
                  {itemData?.analistas?.map((itemAnal, iAnal) => (
                    <div className="item-analista row no-margin" key={itemAnal?.id}>
                      <div className="col s12 m4 l4">
                        <Label title="Título do Item" style={{ paddingRight: '10px' }}>
                          <Input
                            placeholder="Título do Item"
                            name={'tituloItem' + iAnal}
                            value={itemAnal?.titulo || ''}
                            onChange={e => {
                              const v = e.currentTarget.value || '';
                              setAtividades(prev => {
                                const newPrev = [...prev];
                                let analistas = [];
                                let count = 0;

                                for (const itemAnal of newPrev[index].analistas) {
                                  if (count == iAnal) {
                                    analistas.push({ ...itemAnal, titulo: v });
                                  } else {
                                    analistas.push(itemAnal);
                                  }

                                  count++;
                                }
                                newPrev[index].analistas = analistas;

                                return newPrev;
                              });
                            }}
                          />
                        </Label>
                      </div>
                      <div className="col s12 m4 l4" style={{ paddingRight: '10px' }}>
                        <Label title="Analista">
                          <Select
                            isString
                            list={{ list: analistas, value: 'id', label: 'nome' }}
                            name={'idAnalista' + iAnal}
                            firstOption
                            required="true"
                            onChange={e => {
                              const v = e.currentTarget.value || 0;
                              setAtividades(prev => {
                                const newPrev = [...prev];
                                let analistas = [];
                                let count = 0;

                                for (const itemAnal of newPrev[index].analistas) {
                                  if (count == iAnal) {
                                    analistas.push({ ...itemAnal, idAnalista: parseInt(v) });
                                  } else {
                                    analistas.push(itemAnal);
                                  }

                                  count++;
                                }
                                newPrev[index].analistas = analistas;

                                return newPrev;
                              });
                            }}
                            value={itemAnal?.idAnalista}
                          />
                        </Label>
                      </div>
                      <div className="col s12 m2 l2" style={{ paddingRight: '10px' }}>
                        <Label title="Hora Total">
                          <Input
                            type="number"
                            name={'horaTotal' + iAnal}
                            min="1"
                            required="true"
                            value={itemAnal?.horaTotal}
                            onChange={e => {
                              const v = e.currentTarget.value || 0;
                              setAtividades(prev => {
                                const newPrev = [...prev];
                                let analistas = [];
                                let count = 0;
                                let horaTotal = 0;

                                for (const itemAnal of newPrev[index].analistas) {
                                  if (count == iAnal) {
                                    horaTotal += parseInt(v);
                                    analistas.push({ ...itemAnal, horaTotal: parseInt(v) });
                                  } else {
                                    horaTotal += itemAnal?.horaTotal;
                                    analistas.push(itemAnal);
                                  }

                                  count++;
                                }
                                newPrev[index].analistas = analistas;
                                newPrev[index].horaTotal = horaTotal;

                                return newPrev;
                              });
                            }}
                          />
                        </Label>
                      </div>
                      <div className="col s12 m2 l2">
                        <Label title="Hr Lib Analista">
                          <Input
                            type="number"
                            name={'horaSaldo' + iAnal}
                            step="0.10"
                            required="true"
                            value={itemAnal?.horaSaldo}
                            onChange={e => {
                              const v = e.currentTarget.value || 0;
                              setAtividades(prev => {
                                const newPrev = [...prev];
                                let analistas = [];
                                let count = 0;
                                let horaSaldo = 0;

                                for (const itemAnal of newPrev[index].analistas) {
                                  if (count == iAnal) {
                                    horaSaldo += parseInt(v);
                                    analistas.push({ ...itemAnal, horaSaldo: parseInt(v) });
                                  } else {
                                    horaSaldo += itemAnal?.horaSaldo;
                                    analistas.push(itemAnal);
                                  }

                                  count++;
                                }
                                newPrev[index].analistas = analistas;
                                newPrev[index].horaSaldo = horaSaldo;

                                return newPrev;
                              });
                            }}
                          />
                        </Label>

                        <div
                          onClick={() => {
                            handleRemoveAnalista(index, iAnal);
                          }}
                          className="icon-button material-icons"
                          style={{ marginTop: '26px', marginLeft: '8px' }}
                        >
                          delete
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </CardAtividade>
      ))}
    </Container>
  );
}

export default AtividadesList;
